const consentList = [
  {
    id: 0,
    topic: '만 14세 이상입니다. (필수)',
    title: '만 14세 이상 이용안내',
    content: `이 사이트의 서비스는 만 14세 이상만 회원가입이 가능합니다.

      다음과 같은 경우 사전 안내 없이 이용 중지되고 재가입이 차단될 수 있습니다.

      (1) 다른 사람의 정보 또는 사실과 다른 정보로 가입하신 경우
      (2) 회원의 자격(서울대학교 치과대학 2005학년도 동기)이 의심스러운 경우
      (3) 법정대리인이 이용 중지를 요청한 경우
    `
  },
  {
    id: 1,
    topic: '서비스 이용약관 (필수)',
    title: `서비스 이용약관`,
    content: `사이트 정보
      이름 : 서울대학교 치과대학 동기모임 2005
      문의 : neuroris@naver.com
      이용약관 시행일자: 2025-10-10

      제 1 장 총칙
      제 1 조 (목적)
      본 약관은 서울대학교 치과대학 동기모임 2005 사이트(이하 사이트라 합니다)가 제공하는 유무선 인터넷 관련 서비스를 이용함에 있어 사이트와 이용자의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.

      제 2 조 (정의)
      1. 사이트라 함은 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신 설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 서비스를 제공하는 사업자의 의미로도 사용합니다.
      2. 사이트라 함은 콘텐츠 산업과 관련된 경제활동을 영위하는 자로서 콘텐츠 및 제반서비스를 제공하는 자를 말합니다.
      3. 서비스라 함은 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 회원이 이용할 수 있는 사이트 관련 제반 서비스를 의미합니다.
      4. 회원이라 함은 사이트와 이용계약을 체결하고 이용자 아이디(ID)를 부여받은 이용자로서 사이트의 정보를 지속적으로 제공 받으며 사이트가 제공하는 서비스를 지속적으로 이용할 수 있는 자를 말합니다.
      5. 콘텐츠라 함은 정보통신망이용촉진 및 정보보호 등에 관한 법률 제2조 제1항 제1호의 규정에 의한 정보통신망에서 사용되는 부호,문자,음성,음향,이미지 또는 영상 등으로 표현된 자료 또는 정보로서, 그 보존 및 이용에 있어서 효용을 높일 수 있도록 전자적 형태로 제작 또는 처리된 것을 말합니다.
      6. 이용자라 함은 사이트의 사이트에 접속하여 이 약관에 따라 사이트가 제공하는 콘텐츠 및 제반서비스를 이용하는 회원 및 비회원을 말합니다.
      7. 아이디(ID)라 함은 회원의 식별과 서비스이용을 위하여 회원이 정하고 사이트가 승인하는 문자 또는 숫자의 조합을 말합니다.
      8. 비밀번호(PASSWORD)라 함은 회원이 부여받은 아이디(ID)와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 말합니다.
      9. 개인정보란 생존하는 개인에 관한 정보로서 해당 정보에 포함되어 있는 성명, 생년월일 등의사항에 의하여 해당 개인을 식별할 수 있는 정보(해당 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함)를 말합니다.
      10. 게시물이란 회원이 서비스를 이용함에 있어 서비스상에 게시한 부호, 문자, 음향, 음성, 화상, 동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.
      11. 회원탈퇴란 회원이 서비스의 이용계약을 해지하는 것을 의미합니다.
      12. 제휴사란 사이트와 공동 협력을 통해 회원에게 다양한 서비스와 혜택을 제공하는 제3의 서비스 및 마케팅 협력사를 말합니다.

      제 3 조 [신원정보 등의 제공]
      사이트는 약관의 내용, 상호, 문의처를 이용자가 쉽게 알 수 있도록 회원가입시 약관에 표시합니다.

      제 4 조 (약관의 효력 및 변경)
      1. 본 약관은 사이트가 서비스 초기 화면을 통하여 게시하거나 전자우편 기타의 방법으로 회원에게 개별 통지함으로써 효력이 발생합니다.
      2. 본 약관에 동의하여 회원가입을 완료한 회원은, 사이트가 제공하는 모든 서비스를 별도의 추가 가입절차 없이 편리하게 이용할 수 있습니다. 사이트가 운영하는 부속사이트를 이용함에 있어 회원과 사이트간의 권리, 의무 및 책임사항, 이용조건 및 절차 등은 각 서비스 별 약관이나 세부지침의 규정이 없는 사항은 본 약관의 내용을 따릅니다.
      3. 사이트는 관련 법령에 반하지 않는 범위 내에서 본 약관의 내용을 변경할 수 있으며, 적용일자 및 개정사유를 명시하여 현행 약관과 함께 그 적용일자 7일 이전부터 적용일자 전일까지 제1항의 방식으로 공지합니다. 다만 회원에게 불리하게 약관 내용을 변경하는 경우에는 개정 약관의 적용일자 30일 전부터 적용일자 전일까지 공지하는 것 외에 전자우편 기타의 전자적 수단을 통해 별도로 통지합니다.
      4. 전항에 따른 시행일 이후에 서비스를 이용하는 회원은 변경된 약관에 동의한 것으로 간주합니다. 다만 회원은 변경된 약관에 동의하지 않을 경우 이용계약을 해지할 수 있습니다.
      5. 유료서비스를 이용하는 회원이 본 약관의 개정에 동의하지 아니하여 이용계약을 해지하는 경우에는 별도의 유료서비스 약관에 정한 환불정책을 따릅니다.

      제 5 조 (약관의 해석 및 준칙)
      1. 사이트는 개별 서비스에 대하여 별도의 이용약관 및 정책을 둘 수 있으며, 해당 내용이 본 약관과 상충할 경우에는 개별 서비스에 대한 이용약관 및 정책이 우선하여 적용됩니다.
      2. 본 약관에 명시되지 아니한 사항에 대하여는 "전기통신사업법", "정보통신망 이용촉진 및 정보보호 등에 관한 법률"(이하 '정통망법'), 개인정보보호법, 기타 관련 법령에 따릅니다.


      제 2 장 서비스 이용계약
      제 6 조(회원가입)
      1. 회원가입은 이용자가 약관의 내용에 대하여 동의를 하고 회원가입신청을 한 후 사이트가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
      2. 사이트는 상기 이용자의 신청에 대하여 회원가입을 승낙함을 원칙으로 합니다. 다만, 사이트는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않을 수 있습니다.
      ①가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우
      ②실명이 아니거나 타인의 명의를 이용한 경우
      ③허위의 정보를 기재하거나, 사이트가 제시하는 내용을 기재하지 않은 경우
      ④이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
      3. 사이트는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
      4. 제2항 및 제3항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 사이트는 이를 신청자에게 알려야 합니다. 사이트의 귀책사유 없이 신청자에게 통지할 수 없는 경우에는 예외로 합니다.
      5. 회원가입계약의 성립 시기는 사이트의 승낙이 이용자에게 도달한 시점으로 합니다.

      제 7 조 [미성년자의 회원가입]
      1. 만 14세 미만의 이용자는 사이트의 회원가입이 되지 않습니다.

      제 8 조 [회원정보의 변경]
      1. 회원은 개인정보 관리 화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만 서비스의 관리 및 유지를 위하여 필요한 실명, 생년월일,아이디(ID) 등 일부 정보는 임의로 수정할 수 없습니다.
      2. 회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 사이트에 대하여 그 변경사항을 알려야 합니다.
      3. 제2항의 변경사항을 사이트에 알리지 않아 발생한 불이익에 대하여 사이트는 책임지지 않습니다.

      제 9 조 [회원의 아이디(ID) 및 비밀번호의 관리에 대한 의무]
      1. 회원의 아이디(ID)와 비밀번호에 관한 관리책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.
      2. 회원은 아이디(ID) 및 비밀번호가 도용되거나 제3자에 의해 사용되고 있음을 인지한 경우에는 이를 즉시 사이트에 통지하고 사이트의 안내에 따라야 합니다.
      3. 제2항의 경우에 해당 회원이 사이트에 그 사실을 통지하지 않거나, 통지한 경우에도 사이트의 안내에 따르지 않아 발생한 불이익에 대하여 사이트는 책임지지 않습니다.

      제 10 조 (개인정보보호)
      1. 사이트는 이용자의 콘텐츠이용에 필요한 최소한의 정보를 수집할 수 있습니다. 이를 위해 사이트가 문의한 사항에 관해 이용자는 진실한 내용을 성실하게 고지하여야 합니다.
      2. 사이트가 이용자의 개인 식별이 가능한 개인정보를 수집하는 때에는 당해 이용자의 동의를 받습니다.
      3. 사이트는 이용자가 이용신청 등에서 제공한 정보와 제1항에 의하여 수집한 정보를 당해 이용자의 동의 없이 목적 외로 이용하거나 제3자에게 제공할 수 없으며, 이를 위반한 경우에 모든 책임은 사이트가 집니다. 다만, 다음의 경우에는 예외로 합니다.
      ① 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
      ② 콘텐츠 제공에 따른 요금정산을 위하여 필요한 경우
      ③ 도용방지를 위하여 본인확인에 필요한 경우
      ④ 약관의 규정 또는 법령에 의하여 필요한 불가피한 사유가 있는 경우
      4. 사이트가 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는개인정보의 수집목적 및 이용목적, 제3자에 대한 정보제공관련사항(제공받는 자, 제공목적 및 제공할 정보의 내용)등에 관하여 정보통신망이용촉진 및 정보보호 등에 관한 법률 제22조 제2항이 규정한 사항을 명시하고 고지하여야 합니다.
      5. 이용자는 언제든지 제3항의 동의를 임의로 철회할 수 있습니다.
      6. 이용자는 언제든지 사이트가 가지고 있는 자신의 개인정보에 대해 열람 및 오류의 정정을 요구할 수 있으며, 사이트는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 사이트는 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.
      7. 사이트는 개인정보보호를 위하여 관리자를 한정하여 그 수를 최소화하며, 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해에 대하여 책임을 집니다.
      8. 사이트 또는 그로부터 개인정보를 제공받은 자는 이용자가 동의한 범위 내에서 개인정보를 사용할 수 있으며, 목적이 달성된 경우에는 당해 개인정보를 지체 없이 파기합니다.
      9. 사이트는 정보통신망이용촉진 및 정보보호에 관한 법률 등 관계 법령이 정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법령 및 사이트의 개인정보보호정책이 적용됩니다.


      제 3 장 계약 당사자의 의무
      제 11조 (사이트의 의무)
      1. 사이트는 특별한 사정이 없는 한 회원이 서비스 이용을 신청한 날에 서비스를 이용할 수 있도록 합니다.
      2. 사이트는 본 약관에서 정한 바에 따라 계속적이고 안정적인 서비스의 제공을 위하여 지속적으로 노력하며, 설비에 장애가 생기거나 멸실된 때에는 지체 없이 이를 수리 복구하여야 합니다. 다만, 천재지변, 비상사태 또는 그 밖에 부득이한 경우나 사이트의 사정상 서비스 제공이 곤란한 경우에는 그 서비스를 일시 중단하거나 중지할 수 있습니다.
      3. 사이트는 회원으로부터 소정의 절차에 의해 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 적절한 절차를 거쳐 처리하여야 합니다. 처리시 일정 기간이 소요될 경우 회원에게 그 사유와 처리 일정을 알려주어야 합니다.
      4. 사이트는 회원의 프라이버시 보호와 관련하여 본 약관 및 기타 법령에 정한 개인정보의 보호에 관한 규정들을 준수합니다.
      5. 사이트는 이용계약의 체결, 계약사항의 변경 및 해지 등 이용자와의 계약 관련 절차 및 내용 등에 있어 이용자에게 편의를 제공하도록 노력합니다.
      6. 사이트는 서비스 내용별로 이용가능 기간을 정할 수 있으며 이 경우 서비스를 통해 사전 공지합니다.

      제 12 조 (회원의 의무)
      1. 회원은 관련 법령, 본 약관의 각 규정, 이용안내 및 서비스와 관련하여 공지하거나 통지한 주의사항 등을 준수하여야 하며, 기타 사이트의 업무에 방해되는 행위를 하여서는 아니됩니다.
      2. 회원은 내용별로 사이트가 서비스 공지사항에 게시하거나 별도로 공지한 이용제한 사항을 준수하여야 합니다.
      3. 회원은 사이트의 사전승낙 없이는 서비스를 이용하여 영업 기타 영리적 목적의 활동을 할 수 없으며, 그 영업활동의 결과와 회원이 약관에 위반한 영업활동을 하여 발생한 결과에 대하여 사이트는 책임을 지지 않습니다. 회원은 이와 같은 영업활동으로 사이트가 손해를 입은 경우 사이트에 대하여 손해배상 의무를 집니다.
      4. 회원은 사이트의 명시적인 동의가 없는 한 서비스의 이용권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다.
      5. 회원은 서비스 이용과 관련하여 다음 각 호에 해당되는 행위를 하여서는 안됩니다.
      ① 신청 또는 변경 시 허위내용의 기재
      ② 타인의 정보도용
      ③ 사이트에 게시된 정보의 변경
      ④ 사이트가 금지한 정보(컴퓨터 프로그램 등)의 송신 또는 게시
      ⑤ 사이트”와 기타 제3자의 저작권 등 지적재산권에 대한 침해
      ⑥ 사이트 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
      ⑦ 외설 또는 폭력적인 말이나 글, 화상, 음향, 기타 공서양속에 반하는 정보를 사이트의 사이트에 공개 또는 게시하는 행위
      ⑧ 기타 불법적이거나 부당한 행위


      제 4 장 서비스 이용
      제 13 조 (서비스의 제공 등)
      1. 사이트는 회원에게 아래와 같은 서비스를 제공합니다.
      ① TV 및 라디오 방송 콘텐츠 기반 서비스(VOD, AOD, “ON-AIR”, Text등)
      ②SNS 연동 등의 커뮤니케이션 서비스
      ③ 기타 사이트가 추가로 고안하거나 다른 사이트와의 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스
      2..서비스의 이용은 사이트의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간 가능함을 원칙으로 합니다. 다만, 정기 점검 등의 필요로 사이트가 정한 날이나 시간은 그러하지 않습니다.
      3. 사이트는 서비스를 일정범위로 분할하여 각 범위 별로 이용가능 시간을 별도로 정할 수 있습니다. 이 경우 사전에 공지를 통해 그 내용을 알립니다.
      4. 사이트는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 사이트는 본 약관상 정한 방법에 따라 회원에게 통지하되, 사이트가 사전에 통지할 수 없는 부득이한 사유가 있는 경우에는 사후에 통지할 수 있습니다.
      5. 사이트는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에 따릅니다.

      제 14 조 (서비스의 변경 등)
      1. 사이트는 운영상ㆍ기술상의 필요에 따라 제공하고 있는 서비스의 전부 또는 일부를 변경할 수 있습니다.
      2. 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등을 그 변경 전 7일 이상 해당 서비스 초기 화면에 게시합니다.
      3. 사이트는 무료로 제공되는 서비스의 일부 또는 전부를 사이트의 정책 및 운영의 필요에 따라 수정하거나 중단 또는 변경할 수 있습니다.

      제 15 조 (정보의 제공)
      1. 사이트는 회원이 서비스 이용을 위하여 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 회원에게 제공할 수 있습니다.
      2. 사이트는 회원에게 편리하고 다양한 서비스를 제공하기 위하여 관련 법령이 정한 절차와 제한 범위 내에서 회원으로부터 수집한 개인정보를 이용하여 사이트가 제공하는 각종 서비스에 대한 정보, 광고, 타사의 상품이나 서비스, 이벤트 등에 대한 광고를 사이트가 직접 또는 제휴사와 함께 전자우편, DM(우편) 등의 방법으로 광고하거나 제공할 수 있습니다. 이 경우 회원은 관련 법에 따른 거래 관련 정보 및 고객 문의 등에 대한 답변 등을 제외하고는 언제든지 전자우편 등에 대해서 서비스 및 광고를 거절할 수 있습니다.
      3. 사이트는 서비스에 관한 정보 등의 기타 마케팅 및 홍보활동을 함에 있어 TM(텔레마케팅), SMS(핸드폰 문자메세지) 및 모사 전송기기에 의하여 그 정보를 회원에게 전송하고자 하는 경우, 회원의 사전 동의를 받아 전송합니다. 다만 회원의 거래 관련 정보 및 고객문의 등에 대한 답변은 그렇지 아니합니다.
      4. 사이트는 서비스의 운영과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있으며, 광고가 게재된 전자우편 등을 수신한 회원은 수신거절을 할 수 있습니다.
      5. 기타 회원의 정보 제공 및 이용에 관한 세부 사항은 사이트가 정하는 개인정보보호정책에 정한 바를 따릅니다.

      제 16 조 (요금 및 유료정보 등)
      1. 사이트가 제공하는 서비스는 무료서비스와 유료서비스가 있습니다. 사이트 및 제휴사가 제공하는 별도의 유료정보에 대해서는 해당 정보에 명시된 요금을 지불하여야 사용 가능합니다.
      2. 사이트가 제공하는 유료서비스를 이용하고자 하는 회원은 본 약관에서 정의하고 있는 유료서비스 이용약관에 동의하고 사이트에 이용요금(또는 회비)를 납부하여야 합니다.

      제 17 조 (게시물 삭제)
      1. 사이트는 게시판에 정보통신망이용촉진 및 정보보호 등에 관한 법률을 위반한청소년유해매체물이 게시되어 있는 경우에는 이를 지체 없이 삭제 합니다. 다만, 19세 이상의 이용자만 이용할 수 있는 게시판은 예외로 합니다.
      2. 사이트가 운영하는 게시판 등에 게시된 정보로 인하여 법률상 이익이 침해된 자는 사이트에게 당해 정보의 삭제 또는 반박내용의 게재를 요청할 수 있습니다. 이 경우 사이트는 지체 없이 필요한 조치를 취하고 이를 즉시 신청인에게 통지합니다.

      제 18 조 (저작권 등의 귀속)
      1. 사이트가 작성한 저작물에 대한 저작권 기타 지적재산권은 사이트에 귀속합니다.
      2. 사이트가 제공하는 서비스 중 제휴계약에 의해 제공되는 저작물에 대한 저작권 기타 지적재산권은 해당 제공업체에 귀속합니다.
      3. 이용자는 사이트가 제공하는 서비스를 이용함으로써 얻은 정보 중 사이트 또는 제공업체에 지적재산권이 귀속된 정보를 사이트 또는 제공업체의 사전승낙 없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리 혹은 비영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
      4.사이트는 약정에 따라 이용자의 저작물을 사용하는 경우 당해 이용자의 허락을 받습니다.

      제 19 조 [정보의 제공 및 광고의 게재]
      1. 사이트는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편, SMS, 모바일 알림기능 등의 방법으로 회원에게 제공할 수 있습니다.
      2. 제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 회원의 사전 동의를 받아서 전송합니다.
      3. 사이트는 서비스제공과 관련하여 유료서비스화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편 등을 수신한 회원은 수신거절을 사이트에게 할 수 있습니다.

      제 20 조 (서비스 이용 책임)
      회원은 사이트의 권한 있는 사원이 서명한 명시적인 서면을 통하여 구체적으로 허용된 경우를 제외하고는 서비스를 이용하여 상품 등을 판매하는 영업활동을 할 수 없으며 특히 해킹, 돈벌이 광고, 음란 사이트 등을 통한 상업행위, 상용S/W 불법배포 등을 할 수 없습니다. 이를 어기고 발생한 영업활동의 결과 및 손실, 관계기관에 의한 구속 등 법적 조치 등에 관해서 사이트는 책임을 지지 않습니다.

      제 21 조 (서비스 제공의 중지 등)
      1. 무료 서비스의 경우 사이트는 사이트의 필요에 따라 서비스의 전부 또는 일부를 수정 하거나 중지할 수 있습니다.
      2. 사이트는 다음 각 호에 해당하는 경우 서비스 제공을 중지할 수 있습니다.
      ①서비스용 설비의 보수 등 공사로 인한 부득이한 경우
      ② 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우
      ③사이트의 사정에 의하여 서비스 제공이 곤란한 경우나 불가항력적 사유가 있는 경우
      3. 사이트는 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 때에는 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.


      제 5 장 계약 해지 및 이용 제한
      제 22 조 [회원탈퇴 및 자격 상실 등]
      1. 회원은 사이트에 언제든지 탈퇴를 요청할 수 있으며 사이트는 즉시 회원탈퇴를 처리합니다.
      ①“MY>정보수정>회원탈퇴”에서 언제든지 탈퇴를 요청할 수 있으며, 고객센터 e-mail, 전화 등으로 연락하시면 신속하게 개인정보의 삭제 등 필요한 조치를 합니다.
      ②회원탈퇴 시 개인정보는 “개인정보 취급방침”에 따라 관리/삭제 조치되며, 보유 이용권과 개별구매 콘텐츠(영구 소장 포함), 쿠폰 및 무상으로 지급된 코인 모두 소멸되며 해당 서비스를 이용할 수 없습니다.
      ③회원탈퇴 후 다시 신규회원으로 바로 가입 가능합니다.
      2. 회원이 다음 각호의 사유에 해당하는 경우, 사이트는 회원자격을 제한 및 정지시킬 수 있습니다
      ①가입신청 시에 허위내용을 등록한 경우, 서울대학교 치과대학 동기임이 의심스러운 경우
      ②사이트의 서비스이용대금, 기타 사이트의 서비스이용에 관련하여 회원이 부담하는 채무를 기일에 이행하지 않는 경우
      ③다른 사람의 사이트의 서비스 이용을 방해 하거나 그 정보를 도용하는 등 전자 상거래 질서를 위협하는 경우
      ④사이트를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
      3. 사이트는 회원이 제2항의 행위를 한 경우 또는 본 약관의 의무를 위반하는 경우, 그 위반행위의 중대성에 따라 경고, 일시 정지, 영구이용정지 등 서비스의 이용을 단계적으로 제한 할 수 있습니다.
      4. 사이트는 본 약관에 정한 바에 따라 적법한 서비스 이용을 보장 하고 회원을 보호하기 위하여 별도의 이용제한의 조건 및 내용에 대한 세부절차를 정할 수 있습니다.
      5. 회원은 본 약관에 따른 이용제한 등에 대하여 사이트가 정한 절차에 따라 즉시 이의 신청을 할수 있으며, 그 이의 사유가 정당한 것으로 인정되는 경우 사이트는 즉시 서비스의 이용을 재개합니다.

      제 6 장 손해배상 및 기타 사항
      제 23 조 (손해배상)
      1. 사이트가 제공하는 무료서비스를 이용하는 과정에서 발생한 회원의 손실 또는 손해에 관하여, 사이트는 고의 또는 과실로 인하여 발생한 상당인과관계 있는 손해에 대하여 책임을 부담합니다. 다만 회원이 무료서비스를 이용하지 못한 자체에 대하여 사이트는 배상책임이 없습니다.
      2. 사이트는 제휴사가 취급하는 상품 또는 용역에 대하여 책임을 지지 않습니다.

      제 24 조 (면책조항)
      1. 사이트는 천재지변 또는 이에 준하는 불가항력 기타 사이트의 책임없는 사유로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
      2. 사이트는 회원의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.
      3. 사이트는 회원이 서비스를 통해 게재하거나 유포, 전송한 정보, 자료, 사실의 신뢰도, 정확성, 적법성, 안정성 등에 관하여 보장하지 않습니다.
      4. 사이트는 회원간 또는 회원과 제3자 상호간에 서비스를 매개로 하여 이루어진 거래에 대하여 책임을 부담하지 아니합니다.
      5. 사이트는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 부담하지 아니합니다.

      제 25 조 (준거법 및 관할법원)
      1. 사이트와 회원간에 제기된 소송에 대해서는 대한민국 법률을 준거법으로 합니다.
      2. 사이트와 회원간 발생한 분쟁에 관한 소송은 제소 당시의 회원의 주소에 의하고, 주소가 없는 경우 거소를 관할하는 지방법원의 전속관할로 합니다. 단, 제소 당시 회원의 주소 또는 거소가 명확하지 아니한 경우의 관할법원은 민사소송법에 따라 정합니다.
      부칙

      (시행일) 이 약관은 2025년 10월 10일부터 시행합니다.
      `
  },
  {
    id: 2,
    topic: '개인정보 수집, 이용 동의 (필수)',
    title: '개인정보의 수집 및 이용목적/항목/처리 및 보유기간',
    content: `1. 개인정보의 수집 이용 목적: 가입의사 확인, 회원 식별, 인증, 맞춤형 정보추천
      2. 수집 항목: 아이디(ID), 비밀번호, 회원번호, 이름, 이메일 주소, 기기 ID(모바일 단말기)
      3. 동의를 거부할 권리 및 거부 경우의 불이익:
         개인정보를 수집, 이용 동의를 거부할 권리가 있으며, 동의를 거부하실 경우에는 회원에게 제공되는 서비스가 제한될 수 있습니다.
      4. 처리 및 보유기간: 회원 가입시 즉시 처리, 회원 탈퇴 시 즉시 삭제
    `
  },
  {
    id: 3,
    topic: '광고성 정보 수신 동의 (선택)',
    title: '광고성 정보 수신 동의',
    content: `이 사이트는 회원님이 수집 및 이용에 동의한 개인정보를 활용하여, 전자적 전송매체(SMS, 이메일,  PUSH 등 다양한 전송 매체)를 통해, 이벤트 및 마케팅에 대한 광고 정보를 전송할 수 있습니다.

      회원님은 광고 수신에 대한 동의를 거부하실 권리가 있으며, 동의 거부 시에도 서비스의 이용이 가능합니다.

      광고성 정보수신 변경

      1) PUSH, SMS, 이메일 : 로그인 > 마이페이지 > 알림 설정
    
    `
  }
]

export default consentList;